import { useEffect, useState } from "react";
import { User } from "../icons/User";

type RemoteImageProps = {
	src?: string;
	alt: string;
	className?: string;
	draggable?: boolean;
	onClick?: () => void;
};

export const RemoteImage = ({
	src,
	alt,
	className = "",
	draggable = false,
	onClick,
}: RemoteImageProps) => {
	const [isLoading, setIsLoading] = useState(Boolean(src));
	const [hasError, setHasError] = useState(!src);

	useEffect(() => {
		setIsLoading(Boolean(src));
		setHasError(!src);
	}, [src]);

	return (
		<div className={`relative overflow-hidden ${className}`}>
			{(isLoading || hasError) && (
				<div className="absolute inset-0 flex items-center justify-center bg-gray-200">
					{isLoading ? (
						<div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary" />
					) : (
						<User className="h-1/2 w-1/2 text-gray-400" />
					)}
				</div>
			)}
			{src && !hasError && (
				<img
					className="h-full w-full object-cover"
					src={src}
					alt={alt}
					draggable={draggable}
					onClick={onClick}
					onLoad={() => setIsLoading(false)}
					onError={() => {
						setIsLoading(false);
						setHasError(true);
					}}
				/>
			)}
		</div>
	);
};
